import { render, staticRenderFns } from "./ConfirmacaoDeUsoPaciente.vue?vue&type=template&id=5d1c5620&"
import script from "./ConfirmacaoDeUsoPaciente.vue?vue&type=script&lang=js&"
export * from "./ConfirmacaoDeUsoPaciente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports